<template>
    <div
        v-if="item.canReview"
        v-show="hasComments"
        class="badge"
        :class="badgeClasses"
        :key="commentKey"
        content="Tasks in markup - <small>complete / incomplete</small>"
        v-tippy>
        <i class="fas fa-pencil"></i> {{ item.commentsCompletedCount }} / {{ item.commentsCount }}
    </div>
</template>

<script>
export default {
    name: 'MediaComments',
    props: {
        item: {
            type: Object,
            required: true,
        }
    },
    computed: {
        commentKey() {
            return `${this.item.id}-${this.item.commentsCompletedCount}-${this.item.commentsCount}`;
        },
        hasComments() {
            return (this.item.hasCommentsCount);
        },
        badgeClasses() {
            return {
                'badge-success': (this.item.commentsCompletedCount > 0 && this.item.commentsCompletedCount === this.item.commentsCount),
                'badge-warning': (this.item.commentsCompletedCount < this.item.commentsCount),
            }
        }
    },
}
</script>

<style lang="scss" scoped>
@import '~/sass/_variables';

.badge {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    //height: 1.6rem;
    line-height: 1.6rem;
    padding: 0.25rem 0.75rem 0.25rem 0.5rem;
    font-size: 1.1rem;
    border-radius: 10px;
    color: black;
    background-color: map-get($ca-branding, 'light-yellow');
    opacity: 0.8;
    cursor: help;

    i {
        font-size: 90%;
        margin-right: 0.25rem;
    }

    &-success, &-warning {
        color: white;
    }

    &-success {
        background-color: map-get($ca-branding, 'success');
    }

    &-warning {
        background-color: map-get($ca-branding, 'warning');
    }
}
</style>
